import React from "react";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import RouterComponent from "./RouterComponent";
import { store } from "./state/store";

import i18n from "./translations/i18n";

const routing = (
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <Router>
          <RouterComponent />
        </Router>
      </Provider>
    </I18nextProvider>
  </React.StrictMode>
);

// render
const container = document.getElementById("root");
const root = createRoot(container!);

root.render(routing);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
